<div class="consumption-details">
  <div class="row header">
    <div class="col-6 align-content-start">Type de consommation</div>
    <div class="col-2">Nbre de corresp.</div>
    <div class="col-2">Volume</div>
    <div class="col-2">Montant</div>
  </div>
  @for (consumptionDetails of consumption.included.french; track consumptionDetails; let index = $index) {
    <div class="row" [ngClass]="{'gris-background': setBackgroundColor(index) == true}">
      <div class="col-6">{{ consumptionDetails.label }}</div>
      <div class="col-2">
        @if (consumptionDetails.unit !== 'ko' && !consumptionDetails.label.includes('5G')) {
          <span>
            {{ consumptionDetails.correspondentsNumber }}
            @if (consumptionDetails.unit != 'sec' && consumptionDetails.correspondentsNumber < 200) {
                <span>/200</span>
            }
        </span>
      }
    </div>
    <div class="col-2">{{ consumptionDetails.consumption }}</div>
    <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
  </div>
}
@for (consumptionDetails of consumption.included.international; track consumptionDetails) {
  <div class="row">
    <div class="col-6">{{ consumptionDetails.label }}</div>
    <div class="col-2">
      @if (consumptionDetails.unit !== 'ko' && !consumptionDetails.label.includes('5G')) {
        <span>
          {{ consumptionDetails.correspondentsNumber }}
          @if (consumptionDetails.unit != 'sec' && consumptionDetails.correspondentsNumber < 200) {
            <span>/200</span>
          }
      </span>
    }
  </div>
  <div class="col-2">{{ consumptionDetails.consumption }}</div>
  <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
</div>
}
@for (consumptionDetails of consumption.included.other; track consumptionDetails) {
  <div class="row">
    <div class="col-6">{{ consumptionDetails.label }}</div>
    <div class="col-2">
      @if (consumptionDetails.unit !== 'ko' && !consumptionDetails.label.includes('5G')) {
        <span>
          {{ consumptionDetails.correspondentsNumber }}
          @if (consumptionDetails.unit != 'sec' && consumptionDetails.correspondentsNumber < 200) {
            <span>/200</span>
          }
      </span>
    }
  </div>
  <div class="col-2">{{ consumptionDetails.consumption }}</div>
  <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
</div>
}
<div class="row blue-background">
  <div class="col-10">Montant total des communications &nbsp;<span class="font-weight-bold">incluses</span>&nbsp; facturées : </div>
  <div class="col-2 font-weight-bold">{{ consumption.included.price.toFixed(2).toString().replace('.', ',') }}€</div>
</div>
<!-- *************************************** Not included communication *************************************** -->
@for (consumptionDetails of consumption.notIncluded.french; track consumptionDetails; let index = $index) {
  <div class="row" [ngClass]="{'gris-background': setBackgroundColor(index) == true}">
    <div class="col-6">{{ consumptionDetails.label }}</div>
    <div class="col-2">
      @if (consumptionDetails.unit !== 'ko' && !consumptionDetails.label.includes('5G')) {
        <span>
          {{ consumptionDetails.correspondentsNumber }}
            @if (consumptionDetails.unit != 'sec' && consumptionDetails.correspondentsNumber < 200) {
              <span>/200</span>
            }
      </span>
    }
  </div>
  <div class="col-2">{{ consumptionDetails.consumption }}</div>
  <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
</div>
}
@for (consumptionDetails of consumption.notIncluded.international; track consumptionDetails) {
  <div class="row">
    <div class="col-6">{{ consumptionDetails.label }}</div>
    <div class="col-2">
      @if (consumptionDetails.unit !== 'ko' && !consumptionDetails.label.includes('5G')) {
        <span>
          {{ consumptionDetails.correspondentsNumber }}
          @if (consumptionDetails.unit != 'sec' && consumptionDetails.correspondentsNumber < 200) {
            <span>/200</span>
          }
      </span>
    }
  </div>
  <div class="col-2">{{ consumptionDetails.consumption }}</div>
  <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
</div>
}
@for (consumptionDetails of consumption.notIncluded.other; track consumptionDetails) {
  <div class="row">
    <div class="col-6">{{ consumptionDetails.label }}</div>
    <div class="col-2">
      @if (consumptionDetails.unit !== 'ko' && !consumptionDetails.label.includes('5G')) {
        <span>
          {{ consumptionDetails.correspondentsNumber }}
          @if (consumptionDetails.unit != 'sec' && consumptionDetails.correspondentsNumber < 200) {
            <span>/200</span>
          }
      </span>
    }
  </div>
  <div class="col-2">{{ consumptionDetails.consumption }}</div>
  <div class="col-2">{{ consumptionDetails.price.toFixed(2).toString().replace('.', ',') }}€</div>
</div>
}
@for (service of consumption.services.list; track service) {
  <div class="row">
    <div class="col-6">{{ service.label }}</div>
    <div class="col-2"></div>
    <div class="col-2"></div>
    <div class="col-2">{{ (service.price * service.amount).toFixed(2).toString().replace('.', ',') }}€</div>
  </div>
}
@if (consumption.notIncluded.french.length > 0 || consumption.notIncluded.international.length > 0 || consumption.notIncluded.other.length > 0 || consumption.services.price != 0) {
  <div class="row blue-background">
    <div class="col-9">Montant total des communications &nbsp;<span class="font-weight-bold">NON incluses</span>&nbsp; facturées : </div>
    <div class="col-3 font-weight-bold">{{ (consumption.notIncluded?.price + consumption.services.price).toFixed(2).toString().replace('.', ',') }}€</div>
  </div>
}
</div>
